const actionTypes = {
  TOGGLE_PRE_SETTLE_DRAWER_VISIBLE: Symbol('TOGGLE_PRE_SETTLE_DRAWER_VISIBLE'),
  SET_PRE_SETTLE_INFO_LOADING: Symbol('SET_PRE_SETTLE_INFO_LOADING'),
  FETCH_PRE_SETTLE_INFO: Symbol('FETCH_PRE_SETTLE_INFO'),
  RESET_PRE_SETTLE_INFO: Symbol('RESET_PRE_SETTLE_INFO'),
  SET_PRE_SETTLE_BIZ_NO: Symbol('SET_PRE_SETTLE_BIZ_NO'),
};

export default actionTypes;
